import { Row, Card, Alert } from "react-bootstrap";

const Test = function (props) {
  return <Row>
      <Card className="border-0 col-md-6 mt-4 p-4">
        <p>
          You can just paste this piece of code to your website and you can
          already use our service (invite friends).
        </p>
        <code className="mb-4">
          &lt;script src=&quot;{window.location.origin}/getiframe.js&quot;
          useavalanche_script client_id=&quot;
          {localStorage.getItem("client_id")}&quot; client_secret=&quot;
          {localStorage.getItem("client_secret")}
          &quot;&gt;&lt;/script&gt;
        </code>
        <Alert key="note" variant="warning">
          It is desirable to embed the script at the end of the page right
          before closing the <b>&lt;/body&gt;</b> tag.
        </Alert>
      </Card>
    </Row>
};

export default Test;
